import React from "react";
import { tinaField } from "@/lib/utils";
import Section from "./Section";
import TextTooltip from "./TextTooltip";

export default function SeparatorBanner({ separator }) {
  return (
    <Section
      wrapperClassName="relative !py-16"
      style={{
        backgroundImage: `url(${separator?.background})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div className="inset-0 bg-gradient-to-r from-background-blackish/80 to-background-blackish/20 absolute" />
      <div className="relative z-10">
        <h2
          className="h4 md:!text-[36px] max-w-[900px] !leading-relaxed"
          data-tina-field={tinaField(separator, "title")}
        >
          {separator?.title}
        </h2>
        {separator?.description && (
          <TextTooltip
            text={separator?.description}
            className="mt-4 max-w-[600px] p-xl text-foreground-300"
            data-tina-field={tinaField(separator, "description")}
          />
        )}
      </div>
    </Section>
  );
}
